<template>
  <!-- 子组建 -->
  <div class="editor">
    <div ref="toolbar" class="toolbar">  <!-- 头部 -->
    </div>
    <div ref="editor" class="editor-text">  <!-- 内容 -->
    </div>
  </div>
</template>

<script>
import E from 'wangeditor' // 引用

export default {
  name: 'Editorbar',
  data () {
    return {
      editor: null,
      content: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    isClear (val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear()
      }
    },
    value: function (value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value)
      }
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.seteditor()
    this.editor.txt.html(this.value)
  },
  methods: {
    seteditor () {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor)

      this.editor.customConfig.uploadImgShowBase64 = true // base 64 存储图片
      this.editor.customConfig.uploadImgServer = process.env.BASE_FRONT_URL + '/upload/img'// 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {'Authorization': 'Bearer ' + localStorage.getItem('token')}// 自定义 header
      this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 3 // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

      // 配置菜单
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'video',
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          console.log(result)
          this.$notify({
            message: result.data.message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        },
        success: (xhr, editor, result) => {
          console.log(result)
          this.$notify({
            message: result.message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        },
        timeout: (xhr, editor) => {
          this.$notify({
            message: '上传图片超时',
            type: 'warning',
            offset: 100,
            showClose: false
          })
        },
        error: (xhr, editor) => {
          this.$notify({
            message: '图片上传错误',
            type: 'warning',
            offset: 100,
            showClose: false
          })
        },
        customInsert: (insertImg, result, editor) => {
          insertImg(result.data.file_path)
        }
      }
      this.editor.customConfig.onchange = (html) => {
        this.content = html
        this.$emit('content', html)// 将内容上传到父组件里
      }
      // 清楚样式
      this.editor.customConfig.pasteTextHandle = function (pasteStr) {
        var str = pasteStr
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
        str = str.replace(/<\/?[^>]*>/g, '')
        str = str.replace(/[ | ]*\n/g, '\n')
        str = str.replace(/&nbsp;/g, '')
        str = str.replace(/@font-face{[^>]*div.Section0{page:Section0;}/g, '')
        return str
      }
      // 创建富文本编辑器
      this.editor.create()
    }
  }
}
</script>

<style scoped>
  .editor {
    border: 1px solid #ccc;
  }
  .toolbar {
    border-bottom: 1px solid #ccc;
  }
  .editor-text{
    min-height: 200px;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue